import { combineReducers } from 'redux';
import { reducer as acountActivation } from './acountActivation';
import { reducer as isAccountDeactivated } from './isAccountDeactivated';
//import { reducer as resetPassword } from './resetPassword';

export default combineReducers({
    acountActivation,
    isAccountDeactivated
});
